import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isMDM = true;
const termsAndConditionsGet = async (type, options) => {
  const resourcePath = `${Constants.PATH.MDM.TERMS_CONDITIONS.termsConditions}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { type },
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const termsOfDeliveryGet = async (type, options) => {
  const resourcePath = `${Constants.PATH.MDM.TERMS_CONDITIONS.termsOfDelivery}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { termsAndConditionsGet, termsOfDeliveryGet };
